import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatVideo } from '../ai-broker-chat.models';

@Component({
  selector: 'app-chat-video',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="video-wrapper my-2 elevation-2 border-round-lg overflow-hidden surface-card border-1 border-gray-300">
      <video [src]="data().url" controls class="w-full block" preload="metadata"
             [poster]="'assets/video-placeholder.png'">
        Your browser does not support the video tag.
      </video>
      @if (data().name) {
        <div class="p-2 text-xs font-semibold text-color-secondary bg-gray-50 border-top-1 border-gray-300">
          <i class="pi pi-video mr-1"></i>
          {{ data().name }}
        </div>
      }
    </div>
  `,
  styles: [`
    .video-wrapper {
      max-width: 400px;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    }
    video {
      max-height: 500px;
      background: #000;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatVideoComponent {
  data = input.required<ChatVideo>();
}
